import React from 'react';
import { AxisOptions } from 'react-charts';
import Bars from './Utils/BarsChart';
 type MyDatum = { date: Date, stars: number }
 
 export default function MyChart() {
   const data = [
     {
       label: 'React Charts',
       data: [
         {
           date: new Date(),
           stars: 23467238,
         },
       ],
     },
   ]
 
   const primaryAxis = React.useMemo(
     (): AxisOptions<MyDatum> => ({
       getValue: datum => datum.date,
     }),
     []
   )
 
   const secondaryAxes = React.useMemo(
     (): AxisOptions<MyDatum>[] => [
       {
         getValue: datum => datum.stars,
       },
     ],
     []
   )
 
   return (
    <Bars></Bars>
   )
 }